import * as React from 'react';
import autobind from 'autobind-decorator';

import { TransportCompanyOfficeListDataService } from 'src/app/products/office/office.data';
import { OfficeEditorView } from './office-editor.view';

interface OfficeEditorControllerProps {
	value: number | null;
	mode: ControlMode;
	onChanged: (value: TransportCompanyOfficeItem) => void;
	setBusy(isBusy: boolean);
	label?: string;
	supplierId?: number;
	canpPickup?: boolean;
	canpDropOff?: boolean;
	required?: boolean;
}

export class OfficeEditorController extends React.Component<OfficeEditorControllerProps, any> {
	protected officeDataService: TransportCompanyOfficeListDataService;

	constructor(props) {
		super(props);
		this.officeDataService = TransportCompanyOfficeListDataService.make();
	}

	@autobind
	protected officeQuery(q?: string): Promise<QueryResult<TransportCompanyOfficeItem>> {
		return new Promise<QueryResult<TransportCompanyOfficeItem>>((resolve, reject) => {
			this.props.setBusy(true);
			this.officeDataService.addSorting('id', 'asc', true);
			this.officeDataService.addFilter('isDeleted', 'eq', false);
			if (this.props.canpDropOff != null && !this.officeDataService.hasFilter('canDropoff')) {
				this.officeDataService.addFilter('canDropoff', 'eq', true);
			}
			if (this.props.canpPickup != null && !this.officeDataService.hasFilter('canPickup')) {
				this.officeDataService.addFilter('canPickup', 'eq', true);
			}

			this.officeDataService.searchKeywords = q;
			this.officeDataService.load(query => query)
				.then((res) => {
					this.props.setBusy(false);
					resolve({
						items: res,
						totalCount: this.officeDataService.count
					});
				});
		});
	}

	render() {
		return (
			<OfficeEditorView
				officeRequest={{ query: this.officeQuery, dataSet: this.officeDataService }}
				onChanged={this.props.onChanged}
				value={this.props.value}
				mode={this.props.mode}
				label={this.props.label}
				supplierId={this.props.supplierId}
				required={this.props.required}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/office/office-editor.controller.tsx